import { render, staticRenderFns } from "./WebMessagePackets.vue?vue&type=template&id=2c041445&scoped=true"
import script from "./WebMessagePackets.vue?vue&type=script&lang=js"
export * from "./WebMessagePackets.vue?vue&type=script&lang=js"
import style0 from "./WebMessagePackets.vue?vue&type=style&index=0&id=2c041445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c041445",
  null
  
)

export default component.exports